import {makeWebsiteRequest} from "../Common/tools";
import {External, M} from "../external";
import {ORDER_FILTER_TYPE} from "../Filter/static";

export const EMPTY_SALES_TOTALS = {
  orders: 0,
  sales: 0.00
};

export async function getUTMSalesTotals(fromDate, toDate, ...salesUtm) {
  const funnelId = External.Website.getActiveFunnel()?.id;
  const filters = buildSalesUTMFilters(...salesUtm);

  return await getSalesTotals(funnelId, fromDate, toDate, filters, "daily");
}

export async function getSalesTotals(funnelId, fromDate, toDate, filters, grouping) {
  const response = await makeWebsiteRequest({
    action: "getOrderStats",
    method: "post",
    data: {
      type: "sales-totals",
      grouping: grouping,
      funnel: funnelId,
      from: External.Tools.dateToISOStr(fromDate),
      to: External.Tools.dateToISOStr(toDate),
      filters: JSON.stringify(filters)
    }
  });

  return response?.data || EMPTY_SALES_TOTALS;
}

export function buildSalesUTMFilters(...salesUtm) {
  const filters = [[]];

  for (let i = 0; i < salesUtm.length; i++) {
    addOrderPropertyFilter(filters, i, ORDER_FILTER_TYPE.UTM_SOURCE, salesUtm[i].source);
    addOrderPropertyFilter(filters, i, ORDER_FILTER_TYPE.UTM_MEDIUM, salesUtm[i].medium);
    addOrderPropertyFilter(filters, i, ORDER_FILTER_TYPE.UTM_CAMPAIGN, salesUtm[i].campaign);
  }

  return filters;
}

//populates an AND-OR filter structure i.e: [[f,f,f], [f,f,f], [f,f,f]]
export function addOrderPropertyFilter(filters, index, filterTypeId, value) {
  if (!value?.length) {
    return;
  }
  if (!filters[index]) {
    filters[index] = [];
  }
  filters[index][filters[index].length] = {
    func: "is",
    type: External.CRM_FILTER_TYPE.ORDER_PROPERTY,
    id: filterTypeId,
    value: value
  }
}

export function getSalesCountLabel(count) {
  return count === 1 ? M.ONE_SALE : External.format(M.X_SALES, "x", count);
}
